<template>
    <div class="login_container">
      <header>
        <a class="header_logo pc_logo" href="https://www.ubiquitous-p.com/">
          <img src="../assets/logo.jpg">
        </a>
        <a class="header_logo sp_logo" href="https://www.ubiquitous-p.com/">
          <img src="../assets/sp_logo.jpg">
        </a>
      </header>
      <div class="login">
        <div class="login_wrap">
          <div class="login_box">

          <table>
            <tr>
              <th></th>
              <td>
                <p class="login_txt">就業スタッフログイン</p>
                <p v-show="err_catch_401 || err_catch" class="err_msg login_txt" >ログインIDまたはパスワードが間違えています。</p>
              </td>
            </tr>
            <p class="sp_txt">ログインID</p>
            <tr>
              <th>
                <span>ログインID</span>
              </th>
              <td>
                <input type="text" v-model="user.staff_id">
              </td>
            </tr>
            <p class="sp_txt">パスワード</p>
            <tr>
              <th>
                <span>パスワード</span>
              </th>
              <td>
                <input type="password" v-model="user.password">
              </td>
            </tr>
            <tr>
              <th></th>
              <td>
                <button class="login_btn" to="/sLogin" v-on:click="doLogin">ログイン</button>
              </td>
            </tr>
          </table>

          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      user: {},
      err_catch_401: false,
      err_catch: false,
      url_protcol: 'https://',
      domain: 'staff.ubiquitous-p.com',
      url_path: '/rest/login/'

    };
  },
  methods: {
    doLogin() {
      axios.post(this.url_protcol + this.domain + this.url_path,this.user).then(response=>{
        this.$store.dispatch("auth", {
          userName: response.data.user_name,
          userToken: response.data.token
        });
        this.$router.push("/NewsList");
      }).catch(error => {
        if (error.response.status == 401){
          this.err_catch_401 = true
        }else{
          this.err_catch = true
        }
      })
    }
  }
};
</script>

<style scoped>
.login_txt {
  color: #737373;
}

a {
  text-decoration: none;
}

p, .login_btn {
  color: #737373;
  text-align: center;
}

p {
  font-size: 1.5em;
}

tr {
  height: 55px;
}

button.login_btn {
  background: none;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 200px;
  display: block;
  margin: 30px auto 0;
  background-color: #EE9D0B;
  color: #fff;
  border-radius: 15px;
  padding: 5px 30px;
  box-shadow: rgb(158 158 158) 1px 1px 3px;
}

span {
  margin-right: 30px;
  line-height: 40px;
}

input {
  display: block;
  width: 25em;
  height: 40px;
  padding: 0 10px;
  border-radius: 20px;
  border: 1px solid #888;
  box-shadow: rgb(158 158 158) 1px 1px 3px;
}

.login {
  background-size: cover;
  width: 100vw;
  height: 93vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_box {
  background-color: rgba(255, 255, 255, 0.6);
  padding: 80px 200px;
  box-shadow: rgb(228 228 228) 1px 1px 8px;
}

.sp_logo {
  display: none;
}

@media screen and (max-width: 767px) {
    .sp_txt {
      display: block;
      text-align: left;
      font-size: 4vw;
    }

    .login_box {
        padding: 2vw;
    }

    .login_btn {
      background: none;
      border: none;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      display: block;
      margin: 0 auto;
    }

    input {
      width: 85vw;
      margin-bottom: 8vw;
    }

    header img {
    width: 100%;
    }

    a.header_logo {
      width: 100%;
    }

    p, a, td, tr, .header_right a, .header_right p  {
      font-size: 5vw;
    }

    th {
      display: none;
    }

    .sp_logo {
      display: block;
    }
    .pc_logo {
      display: none;
    }
}

.err_msg {
    color: #ff6d6d;
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/sLogin.vue